/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EmergencyContactHouseResponseDto } from './EmergencyContactHouseResponseDto';
export type EmergencyContactResponseDto = {
  /**
   * Correspondence name provided by the owner.
   */
  name: string;
  invitationStatus: EmergencyContactResponseDto.invitationStatus;
  /**
   * ID of the invitation
   */
  invitationId: number;
  /**
   * User id from Cognito
   */
  cognitoUserId: string;
  /**
   * Client phone number including country code
   */
  phoneNumber: string;
  locale: EmergencyContactResponseDto.locale;
  /**
   * Owner's houses which the emergency contact is assigned to.
   */
  houses: Array<EmergencyContactHouseResponseDto>;
  createdAt?: string;
  updatedAt?: string;
};
export namespace EmergencyContactResponseDto {
  export enum invitationStatus {
    PENDING = 'PENDING',
    ACCEPTED = 'ACCEPTED',
  }
  export enum locale {
    EN = 'EN',
    LV = 'LV',
    NO = 'NO',
    FI = 'FI',
  }
}

